import { render, staticRenderFns } from "./feedtrans.vue?vue&type=template&id=a50f8fa8&scoped=true&"
import script from "./feedtrans.vue?vue&type=script&lang=js&"
export * from "./feedtrans.vue?vue&type=script&lang=js&"
import style0 from "./feedtrans.vue?vue&type=style&index=0&id=a50f8fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f8fa8",
  null
  
)

export default component.exports